import { render, staticRenderFns } from "./SearchInspirationBlock.vue?vue&type=template&id=1814c259&"
import script from "./SearchInspirationBlock.vue?vue&type=script&lang=js&"
export * from "./SearchInspirationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports